/* jshint esnext: true */
// global mazeSettings

// @codekit-prepend "lib/properties.js";
// @codekit-prepend "lib/rando.js";
// @codekit-prepend "lib/settings.js";
// @codekit-prepend "lib/map.js";
// @codekit-prepend "lib/helpers.js";




const run = () => {

	settings.init();
	map.generate();

};



domReady(
	function() {

		buttonRandomSeed.addEventListener(
			'click',
			function() {

				inputSeed.value = rando.range( 10000, 99999 );

			}
		);

		/**
		 *
		 */
		setInterval(
			() => { settings.check(); },
			1000
		);

		settings.initToggle();

		if ( 'undefined' !== typeof mazeSettings ) {

			settings.init( mazeSettings[ 0 ], mazeSettings[ 1 ], mazeSettings[ 2 ] );
			settings.randomTileset();
			map.generate();

			return;

		}

		run();

	}
);